import { IconButton } from "@chakra-ui/react"
import {
  EDITOR_MODE,
  useBlocksConfig,
  useSyncer
} from "@pathwright/blocks-engine"
import { AudioPlayer, MediaManager } from "@pathwright/legacy-media-manager"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import { FlashcardAudioChange, FlashcardAudioWrap, FlashcardButton } from "./ui"

export const FlashcardAudio = (props) => {
  const { audio, side, onChangeAudio, isHoverPlaying, mode } = props
  const { contextKey, userID, accountID, isSuperuser } = useBlocksConfig()
  const { blocksContext } = useSyncer()
  const mediaStoragePath = blocksContext?.mediaStoragePath

  const handleChangeAudio = (audioMedia) => onChangeAudio(audioMedia)

  const handleRemoveAudio = () => onChangeAudio(null)

  if (mode !== EDITOR_MODE.EDIT && !audio) return null

  if (mode !== EDITOR_MODE.EDIT && !!audio) {
    return (
      <FlashcardAudioWrap>
        <AudioPlayer
          showControls={false}
          src={audio}
          playing={isHoverPlaying || false}
          renderPlayButton={({ playing, onTogglePlaying }) => (
            <IconButton
              aria-label="Play Audio"
              onClick={(event) => {
                event.preventDefault()
                event.stopPropagation()
                onTogglePlaying()
              }}
              bgColor="transparent"
              minW="1em"
              m="0"
              rounded={true}
              icon={
                <Pathicon
                  icon="audio"
                  size="1em"
                  fill={playing ? "rgb(13, 113, 251)" : ""}
                />
              }
            />
          )}
        />
      </FlashcardAudioWrap>
    )
  }

  return (
    <FlashcardAudioWrap>
      <MediaManager
        contextKey={contextKey}
        documentScope={blocksContext?.documentScope}
        mediaStoragePath={mediaStoragePath}
        mediaType="audio"
        onChooseMedia={handleChangeAudio}
        userID={userID}
        accountID={accountID}
        renderButton={({ onClick }) => (
          <FlashcardAudioChange
            icon={
              <Pathicon
                icon="headphones"
                size="1em"
                fill={audio ? "rgb(13, 113, 251)" : ""}
              />
            }
            onImage={!!side.image}
            onClick={onClick}
          />
        )}
        isSuperuser={isSuperuser}
      />
      {audio && (
        <AudioPlayer
          showControls={false}
          src={audio}
          renderPlayButton={({ playing, onTogglePlaying }) => (
            <FlashcardButton
              onClick={onTogglePlaying}
              className="show-on-hover"
              p="0 0.2rem"
              minWidth="1em"
              border="none"
              bgColor="transparent"
              _hover={{ bg: "transparent" }}
              position="relative"
              mr="0.3rem"
            >
              {playing ? (
                <Pathicon icon="pause" size="1em" />
              ) : (
                <Pathicon icon="play" size="1em" />
              )}
            </FlashcardButton>
          )}
        />
      )}
      {audio && (
        <FlashcardButton
          onClick={handleRemoveAudio}
          className="show-on-hover"
          p="0 0.2rem"
          minWidth="1em"
          border="none"
          bgColor="transparent"
          _hover={{ bg: "transparent" }}
          position="relative"
        >
          <Pathicon icon="trash" size="1em" />
        </FlashcardButton>
      )}
    </FlashcardAudioWrap>
  )
}

export default FlashcardAudio
